<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 24 16" enable-background="new 0 0 24 16" xml:space="preserve">
    <g>
        <defs>
            <rect id="SVGID_1_" width="24" height="16"/>
        </defs>
        <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_"  overflow="visible"/>
        </clipPath>
        <path clip-path="url(#SVGID_2_)" d="M19.5,7C17.015,7,15,9.015,15,11.5s2.015,4.5,4.5,4.5s4.5-2.015,4.5-4.5S21.985,7,19.5,7
             M20,12v2h-1v-2h-2v-1h2V9h1v2h2v1H20z"/>
        <polygon clip-path="url(#SVGID_2_)" points="17,7 14,0 8,13 5,7 0,16 5,10 8,14 14,5 16,8     "/>
    </g>
</svg>

</template>

<script>
export default {
    name: 'IconRefNew',
}
</script>

<style lang="scss" scoped>
</style>